import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaidAdIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PaidAd",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.97 12.14h-1.81v7.25h1.81c1 0 1.81-.81 1.81-1.81v-3.61c0-1-.81-1.81-1.81-1.81Zm-10.01 0c-1 0-1.81.81-1.81 1.81v1.81h3.63v-1.81c0-1-.81-1.81-1.81-1.81ZM16.01 2C8.28 2 2 8.26 2 15.99S8.26 30 15.99 30 30 23.74 30 16.01V16c0-7.73-6.26-13.99-13.99-14m-1.43 19.2h-1.8v-3.66H9.15v3.62h-1.8v-7.2c0-2 1.62-3.62 3.62-3.62s3.62 1.62 3.62 3.62v7.25Zm10.08-3.62c0 2-1.63 3.62-3.63 3.62h-3.67V10.34h3.62c2 0 3.62 1.62 3.63 3.62l.06 3.63Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.75 10.6h2.49l3.99 10.57h-2.22l-.76-2.1H8.73l-.76 2.1H5.76L9.73 10.6Zm2.87 6.66L11 12.74l-1.62 4.52h3.23ZM16.41 17.12c0-2.43 1.69-4.18 3.79-4.18 1.12 0 2.08.45 2.6 1.24v-4.03h2.03v11.03H22.8v-1.09c-.51.79-1.48 1.24-2.6 1.24-2.1 0-3.79-1.77-3.79-4.2Zm6.46.02c0-1.36-.95-2.4-2.22-2.4s-2.23 1.04-2.23 2.4.97 2.39 2.23 2.39 2.22-1.04 2.22-2.39"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
      })]
    })
  }));
};
PaidAdIcon.displayName = 'PaidAdIcon';